/*
 * @Date: 2022-07-04 17:34:53
 * @LastEditors: chuhongguang
 */
export default {
  title: '環境、社會及管治',
  desc: `秉持“讓企業輕松辦公”的使命，以“服務好客戶”為核心，我們助力於幫助企業實現輕資產化轉型，為客戶真正實現降本增效。`
}